export function replaceFieldNameSpecialCharacters(key: string) {
  return key
    .replace(/__dot__/g, '.')
    .replace(/__cma__/g, ',')
    .replace(/__apos__/g, "'");
}
